// LoginForm.js
import React, { useState, useEffect } from 'react';
import { AIRTABLE_NOT_CONFIGURED, getElder } from './Airtable';

const LoginForm = ({ onLogin }) => {
  const [email, setEmail] = useState('');

  useEffect(() => {
    const storedEmail = localStorage.getItem('email');
    if (storedEmail) {
      setEmail(storedEmail);
    }
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const elder = await getElder(email);
      if (elder) {
        localStorage.setItem('email', email);
        onLogin(elder);
      } else {
        alert('Elder not found. Please check your email.');
      }
    } catch (error) {
      console.error('Unable to access verification data:', error);
      alert(error?.code === AIRTABLE_NOT_CONFIGURED
        ? 'Verification data is not available in this environment.'
        : 'Unable to access verification data. Please try again.');
    }
  };

  return (
    <div className="login-box">
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit">Login</button>
      </form>
    </div>
  );
};

export default LoginForm;
